// @ts-ignore

import { Typography, Box } from "@material-ui/core";
import { Tooltip } from "components/shared";
import { ExcellIcon, CsvIcon } from "components/Icons";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import XLSX, { BookType } from "xlsx";
import { convertDateAndTime, getOrderStatusDescription } from "utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dwButtonExcell: {
      alignSelf: "center",
      marginRight: 10,

      height: 40,
      width: 40,
      background: "transparent",

      color: "white",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
      "&:hover": {
        background: "#dde0e2",
        border: "1px solid lightgreen",
      },
    },
    box: {
      display: "flex",
      alignItems: "center",
      margin: "12px 0 0 0",
    },
  })
);

type TableExcell = {
  dataToConvert: any;
  type: string;
};

export default function TableDownload({ dataToConvert, type }: TableExcell) {
  const classes = useStyles();

  const endComplement = (adressArray: any) => {
    if (adressArray.length === 0) return "";
    let finalString = "";
    adressArray.forEach((item: any) => {
      if (item.DSCOMPLEMENTO) {
        if (item.VLCOMPLEMENTO) {
          finalString =
            finalString + item.DSCOMPLEMENTO + " " + item.VLCOMPLEMENTO + " | ";
        } else {
          finalString = `${finalString + item.DSCOMPLEMENTO} - | `
          // finalString + item.DSCOMPLEMENTO + " " + "-" + " | ";
        }
      }
    });
    return finalString;
    // const string = `${adressArray[0]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[0]?.VLCOMPLEMENTO ?? ""
    // } ${adressArray[1]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[1]?.VLCOMPLEMENTO ?? ""
    // } ${adressArray[2]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[2]?.VLCOMPLEMENTO ?? ""
    // }`;
    // return string;
  };

  const dateNow = () => {
    const date = new Date();
    const string = `${date.getDate()}${
      date.getMonth() + 1
    }${date.getFullYear()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
    return string;
  };
  // `${dateNow()}_ENC_${mcmName}`

  const downloadExcel = (choice: BookType) => {
    let mcmName = "";
    const selectedMCM = JSON.parse(
      localStorage.getItem("@adminModulockerCondsets") as any
    );
    if (selectedMCM) {
      const format = selectedMCM.label.split(" ").join("_");

      mcmName = format;
    }

    let arrayToExcel = [];
    if (type === "encomendas") {
      arrayToExcel = dataToConvert.map((item: any) => {
        return {
          ID: item.IDTRANSACAO,
          Destinatario: item.NMUSUARIO,
          Complemento: endComplement(item.ENDECOMPL),
          Box: item.NUMERO,
          Tamanho: item.DESCRICAO,
          DataInicio: convertDateAndTime(item.DHINICIO),
          DataFim: convertDateAndTime(item.DHFIM),
          Status: getOrderStatusDescription(item.STTRANSACAO),
        };
      });
    }

    if (type === "destinatarios") {
      arrayToExcel = dataToConvert.map((item: any) => {
        return {
          Destinatario: item.NMUSUARIO,
          Telefone: item.TELEFONE,
          Complemento: item.ENDECOMPL,
          Grupo: item.DSGRUPOUSUARIO,
          // StatusAplicativo: item.STAPP,
          // StatusUsuario: getAddreessesStatusDescription(item.STUSUARIO),
        };
      });
    }

    const workSheet = XLSX.utils.json_to_sheet(arrayToExcel);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, type);
    //Buffer
    // booktype = 'xlsx' | 'xlsm' | 'xlsb' | 'xls' | 'xla' | 'biff8' | 'biff5' | 'biff2' | 'xlml' | 'ods' | 'fods' | 'csv' | 'txt' | 'sylk' | 'html' | 'dif' | 'rtf' | 'prn' | 'eth';
    XLSX.write(workBook, { bookType: choice, type: "buffer" });
    //Binary string
    XLSX.write(workBook, { bookType: choice, type: "binary" });

    switch (type) {
      case "destinatarios":
        XLSX.writeFile(workBook, `${dateNow()}_DESC_${mcmName}.${choice}`);
        break;
      case "encomendas":
        XLSX.writeFile(workBook, `${dateNow()}_ENC_${mcmName}.${choice}`);
        break;
    }
    //Download
  };

  return (
    <Box className={classes.box}>
      <Typography
        variant="caption"
        style={{
          marginRight: 5,
        }}
      >
        Exportar:
      </Typography>
      <Tooltip title="Exportar para o Excel">
        <div>
          <button
            type="button"
            className={classes.dwButtonExcell}
            onClick={() => downloadExcel("xlsx")}
          >
            <img src={ExcellIcon} alt="Excel" width="30px" />
          </button>
        </div>
      </Tooltip>
      <Tooltip title="Exportar CSV">
        <div>
          <button
            type="button"
            className={classes.dwButtonExcell}
            onClick={() => downloadExcel("csv")}
          >
            <img src={CsvIcon} alt="CSV" width="30px" />
          </button>
        </div>
      </Tooltip>
    </Box>
  );
}
